var map = {
	"./AI-money.svg": "ef73",
	"./admin.svg": "ced6",
	"./config.svg": "18fc",
	"./deact.svg": "64a8",
	"./help.svg": "c932",
	"./lang.svg": "e9ae",
	"./layers-fill.svg": "4b9b",
	"./lock.svg": "ab00"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";